module.exports = __webpack_public_path__ + "img/header-title2.ce397b9c.png";